import { TypographyStyles } from '@/styles'
import { Accordion, Text, Link } from '@/ui'
import { useBreakdownTransparency } from '../../../useBreakdownTransparency'

export const QTEFAQs = () => {
  const transparencyEnabled = useBreakdownTransparency()

  return (
    <Accordion type="single" collapsible>
      <Accordion.Item value="faqs">
        <Accordion.Trigger className="w-full">
          <Text variant={TypographyStyles.H2}>Common FAQs</Text>
        </Accordion.Trigger>

        <Accordion.Content>
          <div className="flex flex-col gap-2">
            <Link
              href="https://support.joinheard.com/hc/en-us/articles/22369431571863"
              newPage
            >
              How to make adjustments to quarterly tax estimate
            </Link>

            <Link
              href="https://support.joinheard.com/hc/en-us/articles/10122365411223"
              newPage
            >
              How do I find my quarterly tax payment receipt?
            </Link>

            <Link
              href="https://support.joinheard.com/hc/en-us/articles/4416208116247"
              newPage
            >
              How does Heard calculate quarterly estimated taxes?
            </Link>

            <Link
              href="https://support.joinheard.com/hc/en-us/articles/4416233114647"
              newPage
            >
              Should I pay quarterly taxes from my personal or business bank
              account?
            </Link>

            <Link
              href="https://support.joinheard.com/hc/en-us/articles/4416196188439"
              newPage
            >
              What do you mean by estimate? Can I pay more or less than the
              estimate you gave me?
            </Link>

            <Link
              href="https://support.joinheard.com/hc/en-us/articles/4416233114647"
              newPage
            >
              Can I transfer money from my business account to pay for quarterly
              taxes?
            </Link>

            <Link
              href="https://support.joinheard.com/hc/en-us/sections/4416200689303"
              newPage
              className="text-moss-500"
            >
              View all FAQs
            </Link>
          </div>
        </Accordion.Content>
      </Accordion.Item>

      {transparencyEnabled && (
        <Accordion.Item value="estimateChange">
          <Accordion.Trigger className="w-full">
            <Text variant={TypographyStyles.H2}>
              Why did my estimate change since last quarter?
            </Text>
          </Accordion.Trigger>

          <Accordion.Content>
            <div className="flex flex-col gap-2">
              <Text>
                Each quarter we re-project your year from a longer stretch of
                your books — two months for Q1, four for Q2, seven for Q3, and
                eleven for Q4 — so the projection sharpens as the year fills in.
                A strong or slow recent month moves it, and your projected
                withholding is recalculated at the same time.
              </Text>
              <Text>
                Q4 works differently: it trues up your whole year rather than
                projecting it, so it can move more than the other quarters in
                either direction.
              </Text>
            </div>
          </Accordion.Content>
        </Accordion.Item>
      )}
    </Accordion>
  )
}
